export default "__VITE_ASSET__COisoUzw__"